import { render, staticRenderFns } from "./user-email-template.html?vue&type=template&id=450e24b8&scoped=true&"
import script from "./user-email-template.js?vue&type=script&lang=js&"
export * from "./user-email-template.js?vue&type=script&lang=js&"
import style0 from "./user-email-template.scss?vue&type=style&index=0&id=450e24b8&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "450e24b8",
  null
  
)

export default component.exports